import React from 'react';
import { GRADING_STYLES } from '../utils/grading';
import './GradingLegend.css';

export default function GradingLegend({ grayOutRed = false }: any) {
  return (
    <div className="grading-legend" role="region" aria-label="Grading legend" tabIndex={0}>
      <div className="grading-legend-row">
        {['gray', 'red', 'yellow', 'lightgreen', 'green'].map((color) => {
          const item = GRADING_STYLES[color];
          return (
            <span className="grading-legend-item" key={color} title={item.description}
              style={{ background: grayOutRed && color === 'red' ? GRADING_STYLES.gray.bg : item.bg, color: item.text }}>
              {item.label}
            </span>
          );
        })}
      </div>
    </div>
  );
}
